<mat-card class="checklist-card">
    <mat-card-header class="checklist-card__header">
        <div class="checklist-card__header__title">
            {{ checklist?.name || ('aumico_reports_create_new_checklist' | i18next) }}
        </div>
    </mat-card-header>
    <mat-card-content class="mat-card-content">
        <checklist-form
            [hasFlis]="hasFlis"
            [checklist]="checklist"
            [flis]="flis"
            (onSubmitChecklistForm)="onSubmit($event)"
            (onCancelCheckList)="onCancel()"
        ></checklist-form>
    </mat-card-content>
</mat-card>
